export class MinAggregator {
    constructor(field) {
        this._min = null;
        this._type = 'min';
        this._field = field;
    }
    get field() {
        return this._field;
    }
    get type() {
        return this._type;
    }
    init() {
        this._min = null;
    }
    accumulate(item) {
        const val = (item && item.hasOwnProperty(this._field)) ? item[this._field] : null;
        if (val !== null && val !== '' && !isNaN(val)) {
            if (this._min === null || val < this._min) {
                this._min = parseFloat(val);
            }
        }
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals[this._type] === undefined) {
            groupTotals[this._type] = {};
        }
        groupTotals[this._type][this._field] = this._min;
    }
}
//# sourceMappingURL=minAggregator.js.map